import { Injector } from '@angular/core';
import { BREAKPOINT } from '@spartacus/storefront';

export type KeyWithBreakpoint<T> = { [key in BREAKPOINT]?: T };

export interface SdModalOptionsWithBreakpoints {
  title?: string | KeyWithBreakpoint<string>;
  ignoreOutsideClick?: boolean | KeyWithBreakpoint<boolean>;
  maxWidth?: string | KeyWithBreakpoint<string>;
  modalType?: ModalTypes | KeyWithBreakpoint<ModalTypes>;
  hideCloseButton?: boolean | KeyWithBreakpoint<boolean>;
  closeStrategy?: ModalCloseStrategy | KeyWithBreakpoint<ModalCloseStrategy>;
  injector?: Injector;
}

export interface SdModalOptions {
  title: string;
  ignoreOutsideClick: boolean;
  maxWidth: string;
  modalType: ModalTypes;
  hideCloseButton: boolean;
  closeStrategy: ModalCloseStrategy;
  injector: Injector;
}

export const ModalTypes = {
  Compact: 'compact',
  Standard: 'standard',
  Fullscreen: 'fullscreen',
} as const;

export type ModalTypes = (typeof ModalTypes)[keyof typeof ModalTypes];

export const ModalCloseStrategy = {
  Backdrop: 'backdrop',
  Outside: 'outside',
} as const;

export type ModalCloseStrategy = (typeof ModalCloseStrategy)[keyof typeof ModalCloseStrategy];
